import PropTypes from 'prop-types';
import { Box } from '@qga/roo-ui/components';
import { RefundDisclaimer } from 'components/Disclaimers';
import LineItem from 'components/LineItem';
import * as propTypes from '../../propTypes';

const PointsLineItem = ({ total, paymentMethods }) => (
  <LineItem title="Qantas Points" totals={[total]}>
    {paymentMethods.map((points, index) => (
      <Box key={index} aria-label="Refund to QFF account">
        Refund will be made to <strong>Qantas Frequent Flyer number {points.qffNumber}</strong>
        <RefundDisclaimer.Link />
      </Box>
    ))}
  </LineItem>
);

PointsLineItem.propTypes = {
  total: propTypes.total.isRequired,
  paymentMethods: PropTypes.arrayOf(propTypes.pointsPaymentMethod).isRequired,
};

export default PointsLineItem;
